import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import TextRecord from '../FormInputs/TextRecord';
import BasicTextInput from '../FormInputs/BasicTextInput';
import BasicChipInput from '../FormInputs/BasicChipInput';

export const SORTING_TYPE = 'sort';
export const defaultSorting = () => {
  const randomInteger = Math.floor(Math.random() * 1000);
  const now = new Date().getTime();
  return {
    id: `${now}${randomInteger}`,
    type: SORTING_TYPE,
  };
};

const TRANSLATION_PREFIX = 'resources.quizes.fields.questions';
const TRANSLATION_QUIZ_PREFIX = 'resources.quizes';

class SortingForm extends React.Component {
  category1NameOnChange = (ev) => {
    this.change('category1Name', ev.target.value);
  }
  category1OnChange = (category) => {
    this.change('category1', category);
  }
  category2NameOnChange = (ev) => {
    this.change('category2Name', ev.target.value);
  }
  category2OnChange = (category) => {
    this.change('category2', category);
  }
  change = (key, value) => {
    const delta = {};
    delta[key] = value;
    this.props.onChange(delta, this.props.id);
  }

  render() {
    const {
      category1Name, category1, category2Name, category2,
      translate,
    } = this.props;

    return (
      <>
        <TextRecord
          label={translate(`${TRANSLATION_PREFIX}.type`)}
          value={translate(`${TRANSLATION_QUIZ_PREFIX}.questions.sort`)}
        />
        <BasicTextInput
          value={category1Name}
          onTouch={this.category1NameOnChange}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.category1Name`)}
        />
        <BasicChipInput
          label={translate(`${TRANSLATION_PREFIX}.category1`)}
          chips={category1}
          onChange={this.category1OnChange}
        />
        <BasicTextInput
          value={category2Name}
          onTouch={this.category2NameOnChange}
          floatingLabelText={translate(`${TRANSLATION_PREFIX}.category2Name`)}
        />
        <BasicChipInput
          label={translate(`${TRANSLATION_PREFIX}.category2`)}
          chips={category2}
          onChange={this.category2OnChange}
        />
      </>
    );
  }
}

export default t(SortingForm);
